import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import ManagerBase from "./ManagerBase";
import "Models/Quotation";

import docIcon from "../../images/icons/doc-big.png";
import pdfIcon from "../../images/icons/pdf-big.png";

class QuotationManager extends ManagerBase {
	constructor () {
		super("quotationManager");
		this.remoteClassName = "quotation";
	}

	delete (item, regressSIS = false, deleteReason = "") {
		const rd = NousCore.api.createRequest({ item: { deleteReason, guid: item.guid, regressSIS }});
		const requestedAction = "delete";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			console.log(data);
	
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok",
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	getByCCA (cca) {
		const rd = NousCore.api.createRequest({ item: { cca } });
		const action = "get-by-cca";

		return NousCore.api.send(`${quotationManager.remoteClassName}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const quotationList = Shark.getInstanceList("Quotation", data.items);

						return {
							data: quotationList,
							requestedAction: action,
							status: "ok"
						};
					}
					case 404:
						return {
							data: "",
							requestedAction: action,
							status: "ko"
						};
				}
			}
		});
	}

	getList () {
		const rd = NousCore.api.createRequest();

		return NousCore.api.send(`${quotationManager.remoteClassName}/get-list`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const quotationList = Shark.getInstanceList("Quotation", data.items);

						// quotationList.sort((a, b) => {
						// 	if (a.updatedAt > b.updatedAt) {
						// 		return -1;
						// 	}
						// 	else if (a.updatedAt < b.updatedAt) {
						// 		return 1;
						// 	}
						// });

						//this.status = 0; //pending: 1, accepted: 2, refused: 3, uploaded: 4
						const quotationRecap = {
							1: 0,//pending
							4: 0,//uploaded
						};
						
						quotationList.forEach(item => {
							// eslint-disable-next-line no-prototype-builtins
							if (quotationRecap.hasOwnProperty(item.status)) {
								quotationRecap[item.status]++;
							}
						});

						// const quotationRequiresAttention = quotationList.filter(item => [1, 4].indexOf(item.status) > -1);
						// const quotationRequiresAttentionCount = quotationRequiresAttention.length;
						// const latestQuotationList = quotationList.slice(Math.max(0, quotationList.length - 5), quotationList.length);

						Shark.set({
							// latestQuotationList,
							quotationList,
							// quotationRecap,
							// quotationRequiresAttentionCount,
						});

						quotationManager.emit("listChanged");
						return {
							data: quotationList,
							requestedAction: "get-list",
							status: "ok"
						};
					}
					case 404:
						quotationManager.emit("listGetError");
						return {
							data: null,
							requestedAction: "get-list",
							status: "ko"
						};
				}
			}
		});
	}
	
	getFilteredList ({incrementalRequest, filters, range} = {incrementalRequest: false, filters: null, range: null}) {
		const rd = NousCore.api.createRequest();
		const requestedAction = "get-filtered-list";

		if (range) {
			rd.range = range;
		}

		if (filters) {
			rd.filters = filters;
		}

		return NousCore.api.send(`${quotationManager.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						let quotationList = Shark.getInstanceList("Quotation", data.items);

						if (incrementalRequest) {
							quotationList = [...Shark.get("quotationList"), ...quotationList];
						}

						Shark.set({
							quotationList,
							__quotationListNeedFurtherLoad: data.availableItemCount > quotationList.length,
							__availableFurtherItems: data.availableItemCount - quotationList.length,
						});

						quotationManager.emit("listChanged");
						return {
							data: quotationList,
							requestedAction,
							status: "ok"
						};
					}
					case 404:
						quotationManager.emit("listGetError");
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}
	
	revertStatus (item, newStatus, reason = "") {
		const rd = NousCore.api.createRequest({ item: { reason, guid: item.guid, newStatus }});
		const requestedAction = "revert-status";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			console.log(data);
	
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok",
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	uploadPicture (target) {
		return NousCore.api.uploadFiles(target, "quotation/upload-picture")
		.then((uploadPictureResponse) => {
			console.log({uploadPictureResponse});
			const savedFiles = uploadPictureResponse.payload.items;
			const currQuotation = Shark.get("currQuotation");

			savedFiles.forEach(savedFile => {
				switch (savedFile.rc) {
					case 1:
						currQuotation.extraData.confirmData.pictures.push({
							label: savedFile.name + "." + savedFile.type,
							size: savedFile.size,
							thumbURL: savedFile.thumbnailFilPath || (savedFile.filePath.substr(-3) === "pdf" ? pdfIcon : docIcon),// "/images/icons/" + savedFile.filePath.substr(-3) + ".png",
							type: savedFile.type.toLowerCase(),
							url: savedFile.filePath,
						});
						break;
					case 95:
						break;
					default:
						alert("Attezione, si è verificato il seguente errore:\n\n" + savedFile.errors[0].errorDescription);
				}
			});

			return {
				data: currQuotation,
				status: "ok",
			};
		});
	}






	
	archive (guid) {
		const rd = NousCore.api.createRequest({ item: { guid } });
		const action = "archive";

		return NousCore.api.send(`${quotationManager.remoteClassName}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const quotation = Shark.getInstance("Quotation", data.items[0]);

						return {
							data: quotation,
							status: "ok",
						};
					}
					case 99:
						return {
							data: {},
							status: "ko",
						};
				}
			}
		});
	}

	getByGuid (guid) {
		const rd = NousCore.api.createRequest({ item: { guid } });

		return NousCore.api.send(`${quotationManager.remoteClassName}/get-by-guid`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const quotations = Shark.getInstanceList("Quotation", data.items);

						return {
							data: quotations,
							status: "ok"
						};
					}
					case 404:
						return {
							data: "",
							status: "ko"
						};
				}
			}
		});
	}

	getCCListByAgent () {
		const rd = NousCore.api.createRequest();

		return NousCore.api.send(`${quotationManager.remoteClassName}/get-cca-list-by-agent`, rd)
		.then((data) => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const ccaList = data.items.map(item => item.cca);
						// const ccaList = Shark.getInstanceList(null, data.items);

						return {
							data: ccaList,
							status: "ok"
						};
					}
					case 404:
						return {
							data: null,
							status: "ko"
						};
				}
			}
		});
	}
	getListByClient (client) {
		const rd = NousCore.api.createRequest({ item: { clientGuid: client.guid } });

		// rd.payload = {
		// 	range: {
		// 		first: 0,
		// 		length: 100
		// 	}
		// };

		NousCore.api.send(`${quotationManager.remoteClassName}/get-list-by-client`, rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const siteInfoSheetList = Shark.getInstanceList("SiteInfoSheet", data.items);

						siteInfoSheetList.sort((a, b) => {
							if (a.referenceDate < b.referenceDate) {
								return 1;
							}
							else if (a.referenceDate > b.referenceDate) {
								return -1;
							}
						});

						console.log({ siteInfoSheetList });
						Shark.set("siteInfoSheetList", siteInfoSheetList);

						quotationManager.emit("listChanged");
						break;
					}
					case 404:
						quotationManager.emit("listGetError");
						break;
				}
			}
		});
	}

	getListBySiteInfoSheet (guidList) {
		const rd = NousCore.api.createRequest({ item: { guidList } });

		return NousCore.api.send(`${quotationManager.remoteClassName}/get-list-by-site-info-sheet`, rd)
		.then((data) => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const quotationList = Shark.getInstanceList("Quotation", data.items);
						console.log(quotationList);
						// quotationList.sort((a, b) => {
						// 	if (a.referenceDate > b.referenceDate) {
						// 		return -1;
						// 	}
						// 	else if (a.referenceDate < b.referenceDate) {
						// 		return 1;
						// 	}
						// });

						
						// const quotationListProvinceForFilter = new Set();
						// quotationList.forEach(item => item.siteInfoSheetData.clientProvince !== "" ? quotationListProvinceForFilter.add(item.siteInfoSheetData.clientProvince) : false);

						// const quotationRequiresAttention = quotationList.filter(item => [1, 4].indexOf(item.status) > -1);
						// const quotationRequiresAttentionCount = quotationRequiresAttention.length;

						// console.log({ quotationList });
						// Shark.set({
						// 	latestQuotationList: quotationList.slice(0, 4),
						// 	quotationList,
						// 	quotationListProvinceForFilter: Array.from(quotationListProvinceForFilter).sort(),
						// 	quotationRequiresAttentionCount,
						// });

						return {
							data: quotationList,
							status: "ok",
						};
					}
					case 404:
						return {
							data: "",
							status: "ko",
						};
				}
			}
		});
	}

	getListByAgentAndClient (userGuid, clientGuid) {
		const rd = NousCore.api.createRequest({ item: { userGuid: userGuid, clientGuid: clientGuid } });

		NousCore.api.send(`${quotationManager.remoteClassName}/get-list-by-agent-and-client`, rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const siteInfoSheetList = Shark.getInstanceList("SiteInfoSheet", data.items);

						siteInfoSheetList.sort((a, b) => {
							if (a.referenceDate > b.referenceDate) {
								return 1;
							}
							else if (a.referenceDate < b.referenceDate) {
								return -1;
							}
						});

						console.log("siteInfoSheetList", siteInfoSheetList);
						Shark.set("siteInfoSheetList", siteInfoSheetList);

						quotationManager.emit("listChanged");
						break;
					}
					case 404:
						quotationManager.emit("listGetError");
						break;
				}
			}
		});
	}

	save (quotation) {
		// return new Promise((resolve, rejects) => {
		const rd = NousCore.api.createRequest({ item: quotation.export() });
		const action = quotation.guid === "" ? "insert" : "update";
		
		return NousCore.api.send(`${quotationManager.remoteClassName}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						quotation.import(data.items[0]);
						quotation.clean();
						console.log("currQuotation", quotation);
						quotationManager.emit("saved");
						// resolve({status: "ok", data: quotation});

						return {
							data: quotation,
							requestedAction: action,
							status: "ok"
						};
					case 99:
						quotationManager.emit("saveError");
						// rejects({status: "ko"});
						return {
							data: null,
							error: data.error,
							requestedAction: action,
							status: "ko"
						};
				}
			}
		});
		// });
	}
}

const quotationManager = new QuotationManager();

Shark.registerController(quotationManager);

export { quotationManager };
